<template>
  <div class="score-entry">
    <el-dialog title="学生成绩修改" :visible.sync="scoreEditShow" width="50%" :before-close="dialogClose">
      <el-table :data="scoreInfo.courseInfoList" border style="width: 300px; margin: 0 auto; max-height: 300px; overflow-y: auto">
        <el-table-column label="科目" prop="courseName"></el-table-column>
        <el-table-column label="成绩">
          <template slot-scope="scope">
            <el-input v-model="scope.row.score"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-list">
        <el-button type="primary" plain @click="dialogClose">取消</el-button>
        <el-button type="primary" @click="scoreEditSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['scoreEditShow', 'scoreInfo'],
  data() {
    return {
    };
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:scoreEditShow", false);
    },
    scoreEditSubmit() {
      this.$emit("scoreEditSubmit", this.scoreInfo);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./scoreEditDialog.scss";
</style>